import { useState } from 'react'

import AlertCircleIcon from '@/assets/icons/alert-circle.svg?react'
import CrossIcon from '@/assets/icons/cross.svg?react'
import { Trans } from '@/components/Trans'

// once dismissed manually, the alert stays hidden across sessions
const DISMISS_STORAGE_KEY = 'subscription_credit_alert_dismissed'

export function SubscriptionCreditAlert() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_STORAGE_KEY) === 'true',
  )

  if (dismissed) return null

  return (
    <div
      className="w-full flex items-center gap-4 p-4 rounded-lg border border-warning/60 bg-warning/10"
      data-ai-component="subscription-credit-alert"
    >
      <AlertCircleIcon className="w-5 h-5 shrink-0 text-warning" />
      <div className="flex-1 t-sm text-warning">
        <Trans i18nKey="create.subscriptionCreditAlert">
          Subscription uses Recharged Credits only. Other credit types can only be used for
          pay-as-you-go.
        </Trans>
      </div>
      <div
        className="shrink-0 cursor-pointer text-secondary"
        onClick={() => {
          localStorage.setItem(DISMISS_STORAGE_KEY, 'true')
          setDismissed(true)
        }}
        aria-label="Dismiss"
      >
        <CrossIcon className="w-4 h-4" />
      </div>
    </div>
  )
}
